import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { FormGroup, InputGroup, InputGroupAddon, Input, Button, FormFeedback } from 'reactstrap';
import FontAwesome from 'react-fontawesome';


import { subscribeNewsletterVisitorRequest, subscribeNewsletterRequest, getLoggedUser, checkPassword, isUserSubscribedToNewsletter } from '../../UserActions';

class UserNewsletterSubscribe extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            result: null,
            isLoading: false,
            errorFields: [],
        };
    }

    handleChange = event => {
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;
        this.setState({
            [name]: value,
        });
    }

    handleSubmit = event => {
        if(this.props.user || (this.state.email && checkPassword(this.state.email))) {
            this.setState({
                isLoading: true,
                errorFields: [],
            });
            this.props.dispatch(
                this.props.user
                ? subscribeNewsletterRequest('general', true)
                : subscribeNewsletterVisitorRequest(this.state.email, this.props.intl.locale),
            ).then(isOk => {
                console.log('request result', isOk);
                this.setState({
                    isLoading: false,
                    result: isOk,
                });
            });
        } else {
            this.setState({
                errorFields: ['email'],
            });
        }
    }

    render() {
        if(this.state.result !== null) {
            return (
                <strong className={classnames('ml-4', 'pl-5', this.state.result ? 'text-sucess' : 'text-danger')}>
                    {
                        this.state.result
                        ? <FormattedMessage id="userNewsletterSubscribeSuccess" defaultMessage="Well done ! You have successfully subscribed to our newsletter!" />
                        : (
                            <Fragment>
                                <FormattedMessage id="userNewsletterSubscribeError" defaultMessage="We were unable to register you as a subscriber, please try again." />
                                <Button color="link" size="sm" onClick={() => this.setState({ result: null })}><FontAwesome name="sync-alt" /></Button>
                            </Fragment>
                        )
                    }
                </strong>
            );
        }
        if(this.props.user) {
            if(isUserSubscribedToNewsletter(this.props.user, 'general')) {
                return (
                    <div className="ml-4 pl-5">
                        <FormattedMessage id="userSubscribeNewsletterConfirmation" defaultMessage="You already subscribed to our newsletter! Thank you!" />
                    </div>
                );
            }
            return (
                <div className="ml-4 pl-5">
                    <Button color="success" size="sm" onClick={this.handleSubmit}><FormattedMessage id="userSubscribeNewsletterButton" defaultMessage="I subscribe" /></Button>
                </div>
            );
        }
        return (
            <FormGroup>
                <InputGroup className={classnames(this.state.errorFields.includes('email') && 'has-danger')}>
                    <Input type="email" name="email" value={this.state.email} disabled={this.state.isLoading} onChange={this.handleChange} placeholder={this.props.intl.formatMessage({ id: 'userEmailFillInfo', defaultMessage: 'Please fill your email' })} invalid={this.state.errorFields.includes('email')} />
                    {this.state.errorFields.includes('email') && <FormFeedback tooltip><FormattedMessage id="userEmailError" defaultMessage="Your email address is incorrect!" /></FormFeedback>}
                    {this.state.email && <InputGroupAddon addonType="append"><Button color="success" onClick={this.handleSubmit} disabled={this.state.isLoading}>{this.state.isLoading ? <FontAwesome name="spinner" spin /> : <FontAwesome name="check-circle" />}</Button></InputGroupAddon>}
                </InputGroup>
            </FormGroup>
        );
    }
}

function mapStateToProps(store, props) {
    return {
        user: getLoggedUser(store),
    };
}

UserNewsletterSubscribe.defaultProps = {
    user: null,
};

UserNewsletterSubscribe.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    user: PropTypes.object,
};

export default connect(mapStateToProps)(injectIntl(UserNewsletterSubscribe));
